module.exports = __webpack_public_path__ + "img/2.0e6d44d4.png";